// extracted by mini-css-extract-plugin
export default {"root":"uPKAViLu","heading":"_2pnMnhRy","counterBlock":"RIAW4QfJ","counter":"_14oSbjuc","green":"_2Q-iTf6H","red":"_1POV42yd"};